import {pollinate} from './pollination/';
import type {TypePollen} from './pollination/pollen';

const pollinateSproutLink = (spec: TypePollen, extraProperties: any = {}) => {
	pollinate(spec, extraProperties);
};

export {pollinateSproutLink};
